import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ca-table-expand-icon',
    templateUrl: './table-expand-icon.component.html',
    styleUrls: ['./table-expand-icon.component.scss'],
})
export class TableExpandIconComponent {
    @Input() expanded: boolean;
    @Input() disabled: boolean = false;

    @Output() expandedChange = new EventEmitter<boolean>();

    toggleExpand() {
        this.expanded = !this.expanded;
        this.expandedChange.emit(this.expanded);
    }
}
